import React, { useState } from 'react';
import cn from '@/utils/cn';
import SPAButton from '../shared/SPAButton';
import { dataFrameClass } from '../shared/SPADataTable';
import SPASectionHeading from '../shared/SPASectionHeading';

const PRE_CLASS = 'tw-m-0 tw-max-h-96 tw-p-4 tw-text-xs tw-leading-relaxed tw-text-spa-primary';

// Plato models only part of this object, so the rest (enforced_virtual_keys, redis, timezone) is
// visible nowhere else.
const RawConfig = ({ config }: { config: Record<string, unknown> }) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const json = JSON.stringify(config, null, 2);

  const copy = () => {
    navigator.clipboard?.writeText(json).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }, () => setCopied(false));
  };

  return (
    <section>
      <SPASectionHeading
        meta={(
          <span className="tw-flex tw-gap-2">
            {open && <SPAButton size="xs" variant="secondary" onClick={copy}>{copied ? 'Copied' : 'Copy'}</SPAButton>}
            <SPAButton aria-expanded={open} size="xs" variant="secondary" onClick={() => setOpen(!open)}>
              {open ? 'Hide' : 'Show'}
            </SPAButton>
          </span>
        )}
        title="Raw plugin config"
      />
      {open ? (
        <pre className={cn(dataFrameClass, PRE_CLASS)}>
          {json}
        </pre>
      ) : (
        <p className="tw-m-0 tw-text-sm tw-text-spa-tertiary">
          Exactly what the gateway holds, including the keys this page does not edit.
        </p>
      )}
    </section>
  );
};

export default RawConfig;
